import { createContext, useContext } from "react";

// Simple day/night context consumed by 3D components inside the Canvas.
export const WorldThemeContext = createContext(false);

export function useNight() {
  return useContext(WorldThemeContext);
}
